import React from "react";
import Five from "./Five";

export default function Forecast(props) {
  return (
    <div className="forecast">
      <h4>Weather Forecast</h4>
      <Five />
    </div>
  );
}
